<template>
    <authenticated-layout>
        <v-card class="pa-6">
            <v-card-title
                class="d-flex justify-space-between align-center pa-0 pb-2"
            >
                <span>
                    {{ $t("offersView.Solar panel offer for the customer") }}
                    {{ offer.customer.name }}
                </span>

                <v-btn
                    variant="flat"
                    size="small"
                    color="primary"
                    :href="`/customers/${offer.customer.id}`"
                >
                    {{ $t("offersView.Return") }}
                </v-btn>
            </v-card-title>

            <div class="mt-6">
                <common-options
                    :offerBasis="offerBasis"
                    :roofSheathings="roofSheathings"
                    :extraCosts="extraCostsModel"
                    :price-factors="priceFactors"
                    read-mode
                />

                <div class="grid grid-cols-3 gap-3 pt-10">
                    <sample-pv-offer
                        :offerBasis="offerBasis"
                        :allSolarPanels="allSolarPanels"
                        :allInverters="allInverters"
                        :all-batteries="allBatteries"
                        :defaultInverterId="
                            defaultInverters[
                                offer.extras.meta.samplePvOfferIndex - 1
                            ]
                        "
                        :defaultSolarPanelId="
                            defaultPanels[
                                offer.extras.meta.samplePvOfferIndex - 1
                            ]
                        "
                        :roofSheathings="roofSheathings"
                        :pricing-factors="priceFactors"
                        :minimum-company-margins="minimumCompanyMargins"
                        :base-margins="baseMargins"
                        :solarPanelsNumber="offer.panelsNumber"
                        :offer="offer"
                        :locale="locale"
                        read-mode
                        :auth-user="authUser"
                        :extraCosts="extraCostsModel"
                    />
                </div>
            </div>
        </v-card>
    </authenticated-layout>
</template>

<script>
import AuthenticatedLayout from "@/Layouts/Authenticated";
import CommonOptions from "@/Components/Offer/CommonOptions";
import SamplePvOffer from "../../Components/Offer/SamplePvOffer";
import {ref} from "vue";

export default {
    props: {
        offer: {
            type: Object,
            required: true,
        },
        roofSheathings: {
            type: Array,
            required: true,
        },
        allSolarPanels: {
            type: Array,
            required: true,
        },
        allInverters: {
            type: Array,
            required: true,
        },
        allBatteries: {
            type: Array,
            required: true,
        },
        defaultPanels: {
            type: Array,
            required: true,
        },
        defaultInverters: {
            type: Array,
            required: true,
        },
        priceFactors: {
            type: Array,
            required: true,
        },
        extraCosts: {
          type: Array,
          required: true,
        },
        minimumCompanyMargins: {
            type: Array,
            required: true,
        },
        baseMargins: {
            type: Array,
            required: true,
        },
        locale: {
            type: String,
            required: true,
        },
        authUser: {
            type: Object,
            required: true,
        },
    },
    components: {
        AuthenticatedLayout,
        CommonOptions,
        SamplePvOffer,
    },
    setup(props) {
      console.log(props.offer)

      const extraCostsData = props.extraCosts.map((extraCost) => ({
        id: extraCost.id,
        name: extraCost.name,
        price: parseFloat(extraCost.price),
        selected: props.offer.pdf_additional_rows.filter(function(row) { return (row.id === extraCost.id && row.type === 'extraCost') }).length > 0
      }));

      const extraCostsModel = ref(extraCostsData)

      return { extraCostsModel }
    },
    data() {
        return {
            offerBasis: {
                roof_sheathing: this.offer.roofType,
                lightning_protection:
                    this.offer.extras.meta.lightningProtection,
                grounding: this.offer.extras.pricing.grounding > 0,
                digging: this.offer.extras.pricing.digging > 0,
                digging_length: this.offer.extras.meta.diggingLength,
                lift: this.offer.extras.pricing.lift > 0,
                stuck_tiles: this.offer.extras.pricing.stuckTiles > 0,
                snow_guards: this.offer.extras.pricing.snowGuardRemoval > 0,
                lightning_rod_removal:
                    this.offer.extras.pricing.lightningRodRemoval > 0,
                insurance: this.offer.extras.pricing.insurance > 0,
                imageUpload: null,
                // annualBills: this.offer.annualBills,
                annualConsumption: this.offer.customer.annual_kwh_consumption,
                clientName: this.offer.customer.name,
                clientAddress: this.offer.customer.address,
                pdId: this.offer.customer.pd_id,
                vat_level: parseFloat(this.offer.vatLevel),
            },
        };
    },
};
</script>
